"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function CheckMarkCircle16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "check-mark-circle-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M8,0.2 C9.65100645,0.2 11.2266322,0.71505878 12.5406039,1.65718776 L12.5406039,1.65718776 L11.6082799,2.95748463 C10.5639185,2.20866854 9.31375307,1.8 8,1.8 C4.57583455,1.8 1.8,4.57583455 1.8,8 C1.8,11.4241654 4.57583455,14.2 8,14.2 C11.4241654,14.2 14.2,11.4241654 14.2,8 C14.2,7.50286593 14.1416498,7.0140061 14.02734,6.5401452 L14.02734,6.5401452 L15.5827243,6.16493883 C15.7266178,6.76143658 15.8,7.37623481 15.8,8 C15.8,12.307821 12.307821,15.8 8,15.8 C3.69217895,15.8 0.2,12.307821 0.2,8 C0.2,3.69217895 3.69217895,0.2 8,0.2 Z M14.8206609,1.86159247 L15.9596126,2.98533135 L7.91872657,11.1350722 L4.29998877,7.51778265 L5.43113316,6.38618538 L7.91086802,8.86492782 L14.8206609,1.86159247 Z", id: "Mask", fill: "#000000", fillRule: "nonzero" })));
}
function CheckMarkCircle16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(CheckMarkCircle16Svg, Object.assign({}, svgProps)));
}
exports.default = CheckMarkCircle16;
//# sourceMappingURL=CheckMarkCircle16.js.map